import gql from 'graphql-tag'
import { EnumFields } from '..'

export const MaintenanceBackupTypeFragment = gql`
  fragment MaintenanceBackupType on maintenance_backup_type{
    ${EnumFields}
  }
`
